import { post, postFileDownload, filePost } from '@/utils/request';

// 报销列表
export const getRmbsmList = params => {
  return post(`/app/getRmbsmList`, params);
};
// 详情
export const getRmbsm = params => {
  return post(`/app/getRmbsm`, params);
};
// 详情
export const deleteRmbsm = params => {
  return post(`/app/deleteRmbsm`, params);
};
// 报销添加、编辑
export const editRmbsm = params => {
  return post(`/app/editRmbsm`, params);
};
// 导出报销明细
export const exportRmbsmList = params => {
  return postFileDownload(`/app/exportRmbsmList`, params, { responseType: 'blob' });
};
// 导入excel报销申请
export const readRmbsmFromExcel = params => {
  return filePost(`/app/readRmbsmFromExcel`, params);
};
